import React from "react";
import { Box, Typography, Grid, Container } from "@mui/material";
import { motion } from "framer-motion";
import { fadeInUp, staggerContainer } from "../utils/animations";
import FoundersImage from "../founderimg/Gemini_Generated_Image_b5vv9ab5vv9ab5vv.jpg";

const MissionSection = () => {
  return (
    <Box
      component="section"
      sx={{
        position: "relative",
        py: { xs: 6, md: 8 },
        backgroundColor: "#ffffff",
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
        {/* Section Heading */}
        <Box
          component={motion.div}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={fadeInUp}
          sx={{ textAlign: "center", mb: { xs: 4, md: 5 } }}
        >
          <Box
            sx={{
              display: "inline-block",
              backgroundColor: "rgba(53, 103, 214, 0.1)",
              color: "#3567D6",
              px: { xs: 2, sm: 2.5 },
              py: { xs: 0.75, sm: 1 },
              borderRadius: "9999px",
              fontSize: { xs: "11px", sm: "12px", md: "13px" },
              fontWeight: 600,
              mb: { xs: 1.5, sm: 2 },
              fontFamily: "'Inter', sans-serif",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            Our Mission
          </Box>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "24px", sm: "28px", md: "32px" },
              fontWeight: 700,
              color: "#1D47A4",
              fontFamily: "'Poppins', sans-serif",
              mb: 1,
              lineHeight: 1.2,
            }}
          >
            Transforming Healthcare Through
            <Box component="span" sx={{ color: "#3567D6", display: "block" }}>
              Innovation & Vision
            </Box>
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: "13px", sm: "14px", md: "15px" },
              color: "#64748b",
              fontFamily: "'Inter', sans-serif",
              maxWidth: "600px",
              mx: "auto",
            }}
          >
            Empowering patients and providers with clear, actionable health insights
          </Typography>
        </Box>

        <Grid
          container
          spacing={{ xs: 4, md: 6 }}
          component={motion.div}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={staggerContainer}
          sx={{ alignItems: "center" }}
        >
          {/* Left Side - Founders Image */}
          <Grid
            item
            xs={12}
            md={5}
            component={motion.div}
            variants={fadeInUp}
          >
            <Box
              sx={{
                width: "100%",
                height: { xs: "300px", sm: "400px", md: "500px" },
                borderRadius: "24px",
                background: "linear-gradient(135deg, #E8F2FF 0%, #F0F9FF 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid rgba(53, 103, 214, 0.1)",
                boxShadow: "0 8px 32px rgba(53, 103, 214, 0.08)",
                overflow: "hidden",
                position: "relative",
              }}
            >
              {/* Founders image */}
              <Box
                component="img"
                src={FoundersImage}
                alt="NirogGyan founders"
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
          </Grid>

          {/* Right Side - Mission Statement & Founders Info */}
          <Grid
            item
            xs={12}
            md={7}
            component={motion.div}
            variants={fadeInUp}
          >
            <Box
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              {/* Mission Statement */}
              <Box
                sx={{
                  mb: { xs: 4, md: 5 },
                  position: "relative",
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: -8,
                    left: -16,
                    fontSize: "48px",
                    color: "#3567D6",
                    opacity: 0.2,
                    fontFamily: "'Georgia', serif",
                    lineHeight: 1,
                  }}
                >
                  "
                </Box>
                <Typography
                  component="blockquote"
                  sx={{
                    fontSize: { xs: "20px", sm: "22px", md: "26px" },
                    color: "#1e293b",
                    lineHeight: 1.8,
                    fontFamily: "'Inter', sans-serif",
                    fontStyle: "italic",
                    fontWeight: 400,
                    pl: 3,
                    position: "relative",
                  }}
                >
                  Our mission is to make medical information universally
                  understandable, accessible, and actionable — for every patient,
                  everywhere.
                </Typography>
              </Box>

              {/* Founders Info */}
              <Box
                sx={{
                  pt: { xs: 3, md: 4 },
                  borderTop: "2px solid #E8F2FF",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: { xs: "18px", sm: "20px", md: "22px" },
                    mb: 1,
                    color: "#1D47A4",
                    fontFamily: "'Poppins', sans-serif",
                    lineHeight: 1.3,
                  }}
                >
                  Shweta Gandhi, Joyneel Acharya
                </Typography>
                <Typography
                  sx={{
                    color: "#64748b",
                    fontSize: { xs: "14px", md: "16px" },
                    fontFamily: "'Inter', sans-serif",
                    fontWeight: 500,
                  }}
                >
                  Founders, NirogGyan
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default MissionSection;